export default __webpack_public_path__ + "static/media/category1.9bafb191.svg";